import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";


import { Mail, Phone, MapPin } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import whobanner from "../img/quote.png";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";

const API_URL = "https://api.securxperts.com:8000/forms/quotation";

// const navType = useNavigationType();

// useEffect(() => {
//   if (navType === "PUSH" || navType === "POP") {
//     requestAnimationFrame(() => {
//       window.scrollTo(0, 0);
//     });
//   }
// }, [navType]);

const RequestQuoteDesign = () => {
  const navigate = useNavigate();

  // Force scroll to top on mount with multiple attempts
  useEffect(() => {
    // Disable browser scroll restoration
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    
    // Force scroll to top with multiple attempts
    const forceScrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      if (window.scrollY !== 0) {
        // If still not at top, try again after a short delay
        setTimeout(forceScrollToTop, 50);
      }
    };
    
    forceScrollToTop();
    
    // Additional fallback for stubborn browsers
    setTimeout(forceScrollToTop, 100);
    setTimeout(forceScrollToTop, 300);
    
    // Google Tag Manager tracking
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        event: 'page_view',
        page_title: 'Request A Quote',
        page_location: window.location.href,
      });
    }
    
    // Meta Pixel tracking
    if (typeof window.fbq !== 'undefined') {
      window.fbq('track', 'PageView', {
        page_title: 'Request A Quote'
      });
    }
    
    return () => {
      // Restore scroll restoration when component unmounts
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'auto';
      }
    };
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    countrycode: "+91",
    phone: "",
    service: "",
    message: "",
  });

  const [status, setStatus] = useState({ type: "", message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [showScroll, setShowScroll] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  const nameRegex = /^[A-Za-z\s]+$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^[0-9]{10}$/;

  useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.body.scrollHeight - window.innerHeight;
      const progress = totalHeight > 0 ? (window.scrollY / totalHeight) * 100 : 0;
      setScrollProgress(progress);
      setShowScroll(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () =>
    window.scrollTo({ top: 0, behavior: "smooth" });

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "name") {
      if (!/^[A-Za-z\s]*$/.test(value)) return;
    }

    if (name === "phone") {
      if (!/^[0-9]*$/.test(value)) return;
      if (value.length > 10) return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };




  const isValidPhoneNumber = (number, countryCode) => {
    try {
      const phoneNumber = parsePhoneNumberFromString(
        `${countryCode}${number}`
      );
      return phoneNumber ? phoneNumber.isValid() : false;
    } catch {
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Empty check
    if (
      !formData.name ||
      !formData.email ||
      !formData.phone ||
      !formData.service
    ) {
      setStatus({ type: "error", message: "Please fill all required fields." });
      setIsSubmitting(false);
      return;
    }

    // Name validation
    if (!nameRegex.test(formData.name)) {
      setStatus({ type: "error", message: "Name should contain only alphabets." });
      setIsSubmitting(false);
      return;
    }

    if (!emailRegex.test(formData.email)) {
      setStatus({ type: "error", message: "Please enter a valid email address." });
      setIsSubmitting(false);
      return;
    }

    if (!phoneRegex.test(formData.phone)) {
      setStatus({ type: "error", message: "Phone number must be exactly 10 digits." });
      setIsSubmitting(false);
      return;
    }

    const validPhone = isValidPhoneNumber(
      formData.phone,
      formData.countrycode
    );

    if (!validPhone) {
      setStatus({ type: "error", message: "Please enter a valid phone number for the selected country." });
      setIsSubmitting(false);
      return;
    }

    const payload = {
      name: formData.name,
      email: formData.email,
      country_code: formData.countrycode,
      phoneno: formData.phone,
      service: formData.service,
      message: formData.message,
    };

    try {
      const res = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("Failed");

      // Redirect to thank you page on success
      navigate('/thank-you', { state: { formType: 'quote' } });

    } catch {
      setStatus({ type: "error", message: "Something went wrong. Please try again." });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Navbar />

      {/* Banner */}
      <header className="relative w-full">
        <div
          className="relative w-full h-[317px] bg-center bg-cover bg-no-repeat"
          style={{ backgroundImage: `url(${whobanner})` }}
        >
          <div className="absolute inset-0 bg-black/70 lg:bg-black/60" />

          <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4 z-10">
            <h1 className="text-4xl font-bold mb-4">Request A Quote</h1>
            <div className="flex items-center gap-2 text-sm">
              <Link to="/" className="hover:underline">
                Home
              </Link>
              <svg
                width="7"
                height="10"
                viewBox="0 0 7 10"
                fill="none"
                className="mt-[2px]"
              >
                <path
                  d="M0.297 0.262C0.105 0.426 -0.002 0.648 0 0.878C0.002 1.109 0.113 1.329 0.308 1.492L4.02 4.604L0.366 7.711C0.173 7.875 0.067 8.097 0.069 8.328C0.071 8.558 0.182 8.778 0.377 8.941C0.474 9.022 0.59 9.086 0.717 9.13C0.844 9.174 0.981 9.196 1.118 9.195C1.255 9.194 1.391 9.171 1.518 9.126C1.644 9.081 1.758 9.016 1.854 8.933L6.232 5.212C6.329 5.131 6.405 5.034 6.457 4.927C6.509 4.821 6.535 4.706 6.534 4.591C6.533 4.476 6.505 4.362 6.451 4.256C6.397 4.15 6.319 4.054 6.221 3.974L1.774 0.254C1.677 0.173 1.561 0.109 1.434 0.065C1.307 0.021 1.171 -0.001 1.033 0C0.896 0.001 0.76 0.024 0.634 0.069C0.507 0.114 0.393 0.18 0.297 0.262Z"
                  fill="white"
                />
              </svg>
              <span>Request A Quote</span>
            </div>
          </div>
        </div>
      </header>

      {/* Form Section */}
      <section className="flex-grow py-16 bg-gradient-to-b from-gray-50 to-gray-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col lg:flex-row rounded-3xl shadow-xl bg-white overflow-hidden">

            {/* Left */}
            <div className="lg:w-5/12 p-12 bg-[#282C6A] text-white">
              <h2 className="text-4xl font-extrabold">
                REQUEST A QUOTE
              </h2>
              <p className="mt-4">
                Need a Free Quote? Please Feel Free to Contact Us
              </p>

              <div className="space-y-4 pt-8">
                <div className="flex items-center gap-3">
                  <Phone className="w-5 h-5" />
                  <span>+91 79932 56679</span>
                </div>
                <div className="flex items-center gap-3">
                  <Mail className="w-5 h-5" />
                  <a
                    href="mailto:info@securxperts.com"
                    className="underline"
                  >
                    info@securxperts.com
                  </a>
                </div>
                <div className="space-y-6 text-sm leading-relaxed">
                  <div className="flex items-start gap-3">
                    <MapPin className="mt-1 text-blue-400" />
                    <div>
                      <p className="font-semibold">India Office:</p>
                      <p>3rd Floor, PR R One Towers</p>
                      <p>Plot No 59, DLF Rd, near Radisson Hotel</p>
                      <p>Jayabheri Enclave, Gachibowli, Hyderabad, Telangana 500032</p>



                    </div>
                  </div>

                  <div className="border-t border-white/20 pt-6 flex items-start gap-3">
                    <MapPin className="mt-1 text-blue-400" />
                    <div>
                      <p className="font-semibold">UK Office:</p>
                      <p>194 Gulson Road,</p>
                      <p>Coventry, England, CV1 2JD</p>
                      <p>United Kingdom</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right */}
            <div className="lg:w-7/12 p-12">

              {/* {status.message && (
                <div
                  className={`mb-6 p-4 text-center rounded font-medium ${
                    status.type === "success"
                      ? "bg-green-100 text-green-700"
                      : "bg-red-100 text-red-700"
                  }`}
                >
                  {status.message}
                </div>
              )} */}

              <form onSubmit={handleSubmit} className="space-y-8">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Full Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter your full name"
                    maxLength={60}
                    className="w-full border-b py-2 text-lg focus:outline-none"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Email <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email address"
                    maxLength={60}
                    className="w-full border-b py-2 text-lg focus:outline-none"
                    required
                  />
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Country Code</label>
                    <PhoneInput
                      country="in"
                      enableSearch
                      value={formData.countrycode}
                      onChange={(value, country) =>
                        setFormData((prev) => ({
                          ...prev,
                          countrycode: `+${country.dialCode}`,
                        }))
                      }
                      inputProps={{
                        readOnly: true, // 🚫 prevents typing digits
                      }}
                      containerStyle={{
                        display: "flex",
                        alignItems: "flex-end",
                      }}
                      inputStyle={{
                        width: "100%",
                        border: "none",
                        borderBottom: "1px solid #D1D5DB",
                        fontSize: "18px",
                        height: "42px",
                        paddingLeft: "60px",
                        backgroundColor: "transparent",
                        cursor: "pointer",
                      }}
                      buttonStyle={{
                        border: "none",
                        background: "transparent",
                        marginBottom: "2px",
                      }}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Phone No. <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Enter 10-digit number"
                      className="w-full border-b py-2 text-lg focus:outline-none"
                      required
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Service <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="service"
                      value={formData.service}
                      onChange={handleChange}
                      className="w-full border-b py-2 text-lg focus:outline-none"
                      required
                    >
                      <option value="" disabled>
                        -- Select Service --
                      </option>
                      <option value="web">Web Development</option>
                      <option value="app">Mobile App Development</option>
                      <option value="design">UI/UX Design</option>
                      <option value="marketing">Digital Marketing</option>
                      <option value="consulting">Consulting</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Message</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Tell us about your project"
                    rows="5"
                    className="w-full border-b py-2 text-lg focus:outline-none"
                    
                  />
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full max-w-[180px] bg-[#282C6A] text-white py-2.5 text-sm rounded-md hover:bg-[#1f234f] disabled:bg-gray-400 transition-colors"
                >
                  {isSubmitting ? "Sending..." : "Submit"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      {/* Scroll to Top Button */}
      {showScroll && (
        <div
          onClick={scrollToTop}
          className="scroll-top fixed bottom-6 right-6 z-50 cursor-pointer flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-r from-blue-500 to-blue-700 shadow-xl hover:scale-110 transition-all"
        >
          <svg className="progress-circle -rotate-90 w-12 h-12 absolute" viewBox="0 0 100 100">
            <circle cx="50" cy="50" r="49" fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth="4" />
            <circle
              cx="50"
              cy="50"
              r="49"
              fill="none"
              stroke="white"
              strokeWidth="4"
              strokeDasharray="307.919"
              strokeDashoffset={307.919 - (scrollProgress / 100) * 307.919}
              strokeLinecap="round"
            />
          </svg>

          <svg className="w-6 h-6 text-white relative z-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
          </svg>
        </div>
      )}
    </div>
  );
};

export default RequestQuoteDesign;
